export const followMenu= () => {

    window.addEventListener('scroll', function() {
        var scrollPosition = window.scrollY;
        let header = document.querySelector(".header");
        if(scrollPosition > 50) {
            header.classList.add("header--follow");
        }
        else {
            header.classList.remove("header--follow");
        }
    });
}

